import { registerDestructor } from '@ember/destroyable';
import type Owner from '@ember/owner';
import { service } from '@ember/service';

import Modifier, { type ArgsFor } from 'ember-modifier';

import type { Service } from 'webapp-types';

interface ReactPopupRootSignature {
	Element: HTMLElement;
	Args: {
		Positional: [];
	};
}

/**
 * Marks the element as the host of a React root that floats over the Ember popups (`services/popup`):
 * a click inside it doesn't close them.
 */
export default class ReactPopupRootModifier extends Modifier<ReactPopupRootSignature> {
	@service('popup') declare popupService: Service.Popup;

	private element: HTMLElement | null = null;

	constructor(owner: Owner, args: ArgsFor<ReactPopupRootSignature>) {
		super(owner, args);

		registerDestructor(this, () => this.unregister());
	}

	override modify(element: HTMLElement): void {
		if (this.element === element) {
			return;
		}

		this.unregister();
		this.element = element;
		this.popupService.registerReactPopupRoot(element);
	}

	private unregister(): void {
		if (this.element) {
			this.popupService.unregisterReactPopupRoot(this.element);
			this.element = null;
		}
	}
}
